import { graphql } from "../gql";

export const getAskAutodorSavedPromptsQueryDoc = graphql(`
  query getAskAutodorSavedPrompts($input: AskAutodorGetSavedPromptsInput!) {
    askAutodorGetSavedPrompts(input: $input) {
      ...AskAutodorSavedPromptFragment
    }
  }
`);
